var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCloseRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8945 23.75L30.5352 19.1523C30.793 18.8945 30.793 18.4219 30.5352 18.1641L29.4609 17.0898C29.2031 16.832 28.7305 16.832 28.4727 17.0898L23.875 21.7305L19.2344 17.0898C18.9766 16.832 18.5039 16.832 18.2461 17.0898L17.1719 18.1641C16.9141 18.4219 16.9141 18.8945 17.1719 19.1523L21.8125 23.75L17.1719 28.3906C16.9141 28.6484 16.9141 29.1211 17.1719 29.3789L18.2461 30.4531C18.5039 30.7109 18.9766 30.7109 19.2344 30.4531L23.875 25.8125L28.4727 30.4531C28.7305 30.7109 29.2031 30.7109 29.4609 30.4531L30.5352 29.3789C30.793 29.1211 30.793 28.6484 30.5352 28.3906L25.8945 23.75Z",
    fill: "#FF1493"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCloseRound);
export default __webpack_public_path__ + "static/media/icCloseRound.1f7465fe.svg";
export { ForwardRef as ReactComponent };